import React, { useEffect, useRef, useState } from "react";
import {
  Dropdown,
  Nav,
  Form,
  Card,
  Container,
  Image,
  Modal,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";

//Componets
import { useNavigate } from "react-router-dom";
import CustomToggle from "../../../dropdowns";
import axios from "axios";
import { clearAuthData, getToken } from "../../../../utils/auth";
import toast, { Toaster } from "react-hot-toast";
import { useProjectName } from "../../../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../../Context/UserContext";
import { useLogoLink } from "../../../../Context/LogoLinkContext";
import "./header.css";
import SponsoredHeader from "../../../../views/dashboard/SponsoredHeader";
import { useConnections } from "../../../../Context/ConnectionContext";
import { IoCloseOutline } from "react-icons/io5";
import LocationComponent from "../../../Location/LocationComponent";
import SimpleLocation from "../../../Location/LocationSelector";
import { setCookie, getCookie, deleteCookie } from "cookies-next";
import Cookies from 'js-cookie';
import SearchComponent from "./SearchComponent";

const Header = ({ isRTL }) => {
  const projectName = useProjectName();
  const logoLink = useLogoLink();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };
  const { userData, updateUserProfile } = useUser();
  const minisidebar = () => {
    document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
  };

  const [show, setShow] = useState(false);
  const [userImage, setUserImage] = useState("");

  const [connection, setConnection] = useState([]);
  const { t, i18n } = useTranslation();

  const [isDropdownVisible, setDropdownVisible] = useState(false);
const [showUserDropdown, setShowUserDropdown] = useState(false);

// Add these handler functions after your existing state declarations
const handleDropdownToggle = (isOpen) => {
  setShowUserDropdown(isOpen);
};

const closeUserDropdown = () => {
  setShowUserDropdown(false);
};
  const toggleDropdownLang = () => setDropdownVisible(!isDropdownVisible);
  const closeDropdownLang = () => setDropdownVisible(false);
  const cookiesPut = async (lng) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/cookies`,
        {language:lng},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("User preferences stored successfully")
    } catch (error) {
      console.log("Failed fetching connection", error);
    }
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    
    if (userData?.isCookieConsent) {
            Cookies.set("language", lng, { expires: 30 });
            cookiesPut(lng);
      // setCookie('i18next', lng, {
      //   maxAge: 60 * 60 * 24 * 30, // 30 days
      //   path: '/',
      //   sameSite: 'Lax'
      // });
    }
    
    closeDropdownLang();
  };

  const handleConnection = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setConnection(response.data.data);
    } catch (error) {
      console.log("Failed Fetching Connections", error);
    }
  };

  useEffect(() => {
    handleConnection();
    const intervalId = setInterval(() => {
      handleConnection();
    }, 120000);
    return () => clearInterval(intervalId);
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = (event) => {
    event.preventDefault();
    setShow(true);
  };
  const [user, setUser] = useState("");

  const [viewProfile, setViewProfile] = useState("");
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      updateUserProfile(response.data.data);
      setUserImage(response.data.data.profileImageLink);
      setViewProfile(response.data.data); 
      setUser(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };


  const profileNavigate = () => {
    const countryCode = viewProfile?.country?.toLowerCase() || "country";
    navigate(`/profileview/${countryCode}/${viewProfile?.username}`);
    closeUserDropdown();
  };
  const toMyProfile = () => {
    const countryCode = viewProfile?.country?.toLowerCase() || "country";
    navigate(`/${countryCode}/${viewProfile?.username}`);
    closeUserDropdown();
  };

  
  const [dropdown, setDropdown] = useState(false);
  const [dropdownM, setDropdownM] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsM, setSearchResultsM] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryM, setSearchQueryM] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("people");

  const dropdownRef = useRef(null);

  const openDropdown = () => {
    setDropdown(true);
  };
  const openDropdownM = () => {
    setDropdownM(true);
  };

  const closeDropdown = () => {
    setDropdown(false);
    setDropdownM(false);
    setSearchResults([]);
    setSearchResultsM([]);
    setSelectedCategory("people");
    setSearchQuery("");
    setSearchQueryM("");
  };

  const handleNavigateProfile = (userdata) => {
    setDropdown(false);
    setDropdownM(false);
    const countryCode = userdata?.country?.toLowerCase() || "country";
    navigate(`/profileview/${countryCode}/${userdata?.username}`);
    closeDropdown();
  };
  const handleNavigateCriticalD = (data) => {
    setDropdown(false);
    setDropdownM(false);
    const baseUrl = `${data?.staticContent}?isSearched=true`;
    window.open(baseUrl, "_blank");
    // navigate(`/critical#qrc-tab`)
  };
  const handleNavigateLost = (data) => {
    setDropdown(false);
    setDropdownM(false);
    const baseUrl = `${data?.staticContent}?isSearched=true`;
    window.open(baseUrl, "_blank");
    // navigate(`/device-list`)
  };

  const handleSendRequest = async (userid) => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/connection/sent-request`,
        {
          requestTo: userid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      closeDropdown();

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("Failed Sending Friend Request", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    if (dropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    if (dropdownM) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownM]);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (selectedCategory === "people" && searchQuery.trim() !== "") {
        handleSearch(searchQuery);
      } else if (
        selectedCategory === "critical-D" &&
        searchQuery.trim() !== ""
      ) {
        handleSearchCriticalD(searchQuery);
      } else if (
        selectedCategory === "lost-and-found" &&
        searchQuery.trim() !== ""
      ) {
        handleSearchLostFound(searchQuery);
      } else {
        setSearchResults([]);
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchQuery, selectedCategory]);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (selectedCategory === "people" && searchQueryM.trim() !== "") {
        handleSearchM(searchQueryM);
      } else if (
        selectedCategory === "critical-D" &&
        searchQueryM.trim() !== ""
      ) {
        handleSearchCriticalD(searchQueryM);
      } else if (
        selectedCategory === "lost-and-found" &&
        searchQueryM.trim() !== ""
      ) {
        handleSearchLostFound(searchQueryM);
      } else {
        setSearchResultsM([]);
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchQueryM, selectedCategory]);

  const handleSearchCriticalD = async (query) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/search?searchFor=critical-D&keyword=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSearchResults(response?.data?.data.searchResult);
      setSearchResultsM(response?.data?.data.searchResult);
    } catch (error) {
      console.error("Failed Fetching Search Detail", error);
    }
  };

  const handleSearchLostFound = async (query) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/search?searchFor=lost-and-found&keyword=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSearchResults(response?.data?.data.searchResult);
      setSearchResultsM(response?.data?.data.searchResult);
    } catch (error) {
      console.error("Failed Fetching Search Detail", error);
    }
  };
  const handleSearchqrHero = async (query) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/search?searchFor=social-net&keyword=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSearchResults(response?.data?.data.searchResult);
      setSearchResultsM(response?.data?.data.searchResult);
    } catch (error) {
      console.error("Failed Fetching Search Detail", error);
    }
  };

  const handleSearch = async (query) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/all?userName=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSearchResults(response?.data?.data.userData);
      // setDropdown(true);
    } catch (error) {
      console.error("Failed Fetching Search Detail", error);
    }
  };
  const handleSearchM = async (query) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/all?userName=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSearchResultsM(response?.data?.data.userData);
    } catch (error) {
      console.error("Failed Fetching Search Detail", error);
    }
  };

  useEffect(() => {
    fetchUserData();
    handleSearch();
    handleSearchM();
  }, []);

  const handleCategoryChange = (e) => {
    setSearchQuery("");
    setSearchQueryM("");
    setSearchResults([]);
    setSearchResultsM([]);
    setSelectedCategory(e.target.value);
  };


  const handleChangeM = (e) => {
    setSearchQueryM(e.target.value);
  };

  const handleSubmitM = (e) => {
    // e.preventDefault();
    if (!dropdownM) {
      setDropdownM(true);
    } // Trigger search for the selected category
    if (selectedCategory === "people") {
      handleSearchM(searchQueryM);
    } else if (selectedCategory === "critical-D") {
      handleSearchCriticalD(searchQueryM);
    } else if (selectedCategory === "lost-and-found") {
      handleSearchLostFound(searchQueryM);
    } else if (selectedCategory === "social-net") {
      handleSearchqrHero(searchQueryM);
    }
  };

  const logout = () => {
    clearAuthData();
    navigate("/auth/sign-in");
  };

  const handleLogout = async () => {
    const token = getToken();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      sessionStorage.removeItem("cookies");
      logout();
      // toast.success(response?.data?.messsage || "Logged out successfully")
    } catch (error) {
      console.log("Failed Deleting Condition", error);
      toast.error(
        error?.response?.data?.messsage || "Failed logging out device"
      );
    }
  };

  const [requests, setRequests] = useState([]);
  const [requestsCount, setRequestsCount] = useState(0);

  const handleRequests = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/requests/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setRequests(response.data.data);
      setRequestsCount(response.data.data.length);
    } catch (error) {
      console.log("Failed Fetching Requested to", error);
    }
  };

  useEffect(() => {
    handleRequests();
  }, []);

  const [notification, setNotification] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const handleNotification = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/notification?page=1&limit=500`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotification(response.data.data.notificationData);
      setNotificationCount(response.data.data.noOfEntries);
    } catch (error) {
      console.log("Failed Fetching notification", error);
    }
  };

  useEffect(() => {
    handleNotification();
    const intervalId = setInterval(handleNotification, 15000);
    return () => clearInterval(intervalId);
  }, []);

    const [showN, setShowN] = useState(false);

  const handleToggle = (nextShow) => {
    setShowN(nextShow);
  };

  const clearAllNotifications = async () => {
    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.REACT_APP_URL}/api/user/notification/mark-as-read`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowN(false); 
      setNotification([]);
      handleNotification();
    } catch (error) {
      console.error("Error clearing notifications:", error);
    }
  };

  const handleNavigateProfileRequest = (userid) => {
    navigate(`/userprofile/${userid}`);
  };
  const { connections, handleConnections, loading, error } = useConnections();

  const handleRequestApprove = async (reqid, action) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/connection/request/${reqid}`,
        {
          status: action,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleRequests();
      handleConnections();
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("Failed fetching connection", error);
    }
  };

  const fetchUserCurrency = async (mockCountryCode = null) => {
    try {
      let country_code;

      if (mockCountryCode) {
        country_code = mockCountryCode;
      } else {
        const response = await axios.get("https://ipapi.co/json/");
        country_code = response.data.country_code;
      }

      const countryCurrencyMapping = {
        en: { locale: "en-US", currency: "USD" },
        fr: { locale: "fr-FR", currency: "EUR" },
        de: { locale: "de-DE", currency: "EUR" },
        it: { locale: "it-IT", currency: "EUR" },
        pt: { locale: "pt-PT", currency: "EUR" },
        ar: { locale: "ar-AE", currency: "AED" },
        tr: { locale: "tr-TR", currency: "TRY" },
        ru: { locale: "ru-RU", currency: "RUB" },
        es: { locale: "es-ES", currency: "EUR" },
      };

      // Check for valid mapping
      const currencyData = countryCurrencyMapping[country_code];
      if (!currencyData) {
        console.warn(`No mapping found for country code: ${country_code}`);
        return { locale: "en-US", currency: "USD" }; // Default
      }

      const { locale, currency } = currencyData;

      const formattedCurrency = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
      }).format(1000);

      // console.log(`Currency for ${country_code}: ${formattedCurrency}`);
      return { locale, currency, formattedCurrency };
    } catch (error) {
      console.error("Error fetching geolocation data:", error.message);
      return { locale: "en-US", currency: "USD" }; // Fallback
    }
  };

  useEffect(() => {
    fetchUserCurrency("tr");
  }, []);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch("http://ip-api.com/json/");
        const data = await response.json();
        if (response.ok) {
        } else {
          console.error("Country", data.message || "Unable to fetch location");
        }
      } catch (err) {
        console.error("An error occurred while fetching location.");
      }
    };

    fetchCountry();
  }, []);
  const defaultCurrency = "USD";
  const defaultSymbol = "$";
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency") || defaultCurrency
  );
  const [currencySymbol, setCurrencySymbol] = useState(
    localStorage.getItem("currencySymbol") || defaultSymbol
  );

  useEffect(() => {
const savedCurrency = localStorage.getItem("selectedCurrency");
    if (user?.isCookieConsent) {
      Cookies.set("currency", savedCurrency, { expires: 30 });
    }
        if (!localStorage.getItem("selectedCurrency")) {
      localStorage.setItem("selectedCurrency", defaultCurrency);
      if (userData?.isCookieConsent) {
        Cookies.set("currency", defaultCurrency, { expires: 30 });
      }
    }
    if (!localStorage.getItem("currencySymbol")) {
      localStorage.setItem("currencySymbol", defaultSymbol);
    }

    const fetchCurrencies = async () => {
      const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/data/currencies`;
      const authHeader =
        "Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=";

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: authHeader,
          },
        });
        setCurrencies(response.data);

        // Check if the saved currency exists in the fetched data
        const savedCurrency = localStorage.getItem("selectedCurrency");
        const savedCurrencyData = response.data.find(
          (currency) => currency.code === savedCurrency
        );

        if (savedCurrencyData) {
          setCurrencySymbol(decodeHtmlEntity(savedCurrencyData.symbol));
        } else {
          setCurrencySymbol(defaultSymbol);
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };

    fetchCurrencies();
  }, []);

  const decodeHtmlEntity = (str) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  };

  const timeAgo = (dateString) => {
    const now = new Date();
    const createdAt = new Date(dateString);
    const diffInSeconds = Math.floor((now - createdAt) / 1000);

    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
      second: 1,
    };

    for (let key in intervals) {
      const interval = Math.floor(diffInSeconds / intervals[key]);
      if (interval > 0) {
        return `${interval} ${key}${interval !== 1 ? "s" : ""} ago`;
      }
    }
    return "Just now";
  };

  const [autoDetected, setAutoDetected] = useState("");

  useEffect(() => {
    axios.get("https://ipapi.co/json/")
      .then((res) => {
        const userCountryCode = res.data;
        setAutoDetected(userCountryCode);
      })
      .catch((err) => console.error("Geo error:", err));
  }, []);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="iq-top-navbar" >
        <Nav
          expand="lg"
          variant="light"
          className="nav navbar navbar-expand-lg navbar-light iq-navbar p-lg-0"
        >
          <Container fluid className="navbar-inner">
            <div className="d-flex align-items-center gap-3  pb-2 pb-lg-0">
              <Link
                to="#"
                className="sidebar-toggle d-flex d-lg-none"
                data-toggle="sidebar"
                data-active="true"
                onClick={minisidebar}
              >
                <div className="icon material-symbols-outlined iq-burger-menu">
                  menu
                </div>
              </Link>
              <Link to="/" className="d-flex align-items-center iq-header-logo">
                <img
                  src={logoLink || "/diridologo.jpg"}
                  alt="logo"
                  style={{ height: "45px" }}
                />
              </Link>
              <SimpleLocation autoDetected={autoDetected}/>
              <div
                className="caption d-block d-lg-none"
                style={{
                  width: "100%",
                  marginRight: "60px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    maxHeight: "55px",
                    maxWidth: "300px",
                    marginInline: "auto",
                  }}
                >
                  <SponsoredHeader />
                </div>
              </div>
            </div>
<SearchComponent isRTL={isRTL}/>
            <div className="headerAds">
              <SponsoredHeader />
            </div>
            <ul className="navbar-nav navbar-list">
            
              <Nav.Item as="li" className="d-lg-none">
                {dropdownM && (
                  <div
                    ref={dropdownRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "90vw",
                      overflow: "visible",
                      maxHeight: "none",
                      marginTop: "30px",
                      background: "#fff",
                      border: "1px solid #d3d3d3",
                      borderTop: "none",
                      position: "absolute",
                      zIndex: 999,
                      borderRadius: "0 0 10px 10px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        borderRadius: "5px",
                        // border: "1px solid #a5a5a5",
                        position: "relative",
                        margin: "10px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <SearchComponent isMobile={true} isRTL={isRTL}/>
                    </div>
                   
                  </div>
                )}

                <div className="iq-search-bar device-search position-relative">
                  <div className="searchbox">
                    <Link
                      className="d-lg-none d-flex"
                      onClick={() => { setDropdownM(true);}}
                      style={{ padding: "8px" }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: "24px" }}
                      >
                        search
                      </span>
                    </Link>
                  </div>
                </div>
              </Nav.Item>

              <Dropdown as="li" className="nav-item">
                <Dropdown.Toggle
                  href="#"
                  as={CustomToggle}
                  variant="search-toggle d-flex align-items-center position-relative"
                >
                  <span
                    className="material-symbols-outlined"
                    title="Friend Request"
                  >
                    group
                  </span>
                  {requests?.length > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: window.innerWidth < 992 ? "-1px" : "12px",
                        right: window.innerWidth < 992 ? "-5px" : "8px",
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding:
                          window.innerWidth < 992 ? "2px 2px" : "2px 4px",
                        fontSize: "10px",
                        minWidth: "16px",
                        height: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {requestsCount}
                    </span>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu className="sub-drop sub-drop-large" dir={isRTL ? "rtl" : "ltr"}>
                  <Card className="shadow-none m-0">
                    <Card.Header className="d-flex justify-content-between bg-primary">
                      <div className="header-title">
                        <h5 className="mb-0 text-white">{t("friend_request")}</h5>
                      </div>
                      <small className="badge  bg-light text-dark ">
                        {requestsCount}
                      </small>
                    </Card.Header>
                    <Card.Body className="p-0" style={{background:"#f5f5f7", border:"1px solid #d4d4d4", borderTop:"none", borderRadius:"5px" }}>
                      {requests?.length === 0 ? (
                        <Col>
                          <div className="text-center">
                            <h5 style={{ color: "gray" }}>{t("no_requests")}</h5>
                          </div>
                        </Col>
                      ) : (
                        requests?.map((data, index) => (
                          <div
                            className="iq-friend-request"
                            style={{
                              padding: "10px 0px 10px 15px",
                              marginInline: "10px",
                              borderBottom: "1px solid #D3D3D3",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <div style={{ display: "flex" }}>
                                <Image
                                  className="avatar-40 rounded"
                                  src={
                                    data?.requestBy?.profileImageLink
                                      ? data?.requestBy?.profileImageLink
                                      : "/profile.png"
                                  }
                                  alt=""
                                  loading="lazy"
                                />
                                <div
                                  className="ms-3 text-primary"
                                  style={{
                                    alignItems: "center",
                                    display: "flex",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleNavigateProfileRequest(
                                      data?.requestBy?.UID
                                    )
                                  }
                                >
                                  {data?.requestBy?.firstName}{" "}
                                  {data?.requestBy?.lastName}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Link
                                  to="#"
                                  className="me-3 btn btn-primary rounded"
                                  onClick={() =>
                                    handleRequestApprove(data?._id, "accept")
                                  }
                                >
                                  {t("confirm")}
                                </Link>
                                <Link
                                  to="#"
                                  onClick={() =>
                                    handleRequestApprove(data?._id, "reject")
                                  }
                                  className="me-3 btn btn-secondary rounded"
                                >
                                  {t("delete")}
                                </Link>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </Card.Body>
                  </Card>
                </Dropdown.Menu>
              </Dropdown>
              {/* NOtifications */}
              <Dropdown  as="li"
      className="nav-item"
      show={showN}
      onToggle={handleToggle}>
                <Dropdown.Toggle
                  href="#"
                  as={CustomToggle}
                  variant="search-toggle d-flex align-items-center position-relative"
                >
                  <i
                    className="material-symbols-outlined"
                    title="Notifications"
                  >
                    notifications
                  </i>

                  {userData?.unReadNotificationCount > 0 &&
                    notification?.length > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: window.innerWidth < 992 ? "-1px" : "12px",
                          right: window.innerWidth < 992 ? "-5px" : "8px",
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: "50%",
                          padding:
                            window.innerWidth < 992 ? "2px 2px" : "2px 4px",
                          fontSize: "10px",
                          minWidth: "16px",
                          height: "16px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {userData?.unReadNotificationCount}
                      </span>
                    )}
                </Dropdown.Toggle>
                <Dropdown.Menu className="sub-drop" dir={isRTL ? "rtl" : "ltr"}>
                  <Card className="shadow-none m-0">
                    <Card.Header className="d-flex justify-content-between bg-primary">
                      <div className="header-title bg-primary">
                        <h5 className="mb-0 text-white ">{t("notifications_label")}</h5>
                      </div>
                      <div style={{ display: "flex" }}>
                        {notification?.length > 0 && (
                          <div
                            style={{ display: "flex", justifyContent: "right" }}
                          >
                            <button
                              style={{
                                background: "transparent",
                                color: "white",
                                textDecoration: "underline",
                              }}
                              className="btn btn-sm ms-2"
                              onClick={clearAllNotifications}
                            >
                              {t("clear_all")}
                            </button>
                          </div>
                        )}
                        <small
                          className="badge  bg-light text-dark"
                          style={{ display: "flex" }}
                        >
                          {notificationCount}
                        </small>
                      </div>
                    </Card.Header>
                    <Card.Body
                      className="p-0"
                      style={{ maxHeight: "60vh", overflowY: "auto", background:"#f5f5f7", border:"1px solid #d4d4d4", borderTop:"none", borderRadius:"5px"  }}
                    >
                      {notification?.length === 0 ? (
                        <Col>
                          <div className="text-center">
                            <h5 style={{ color: "gray" }}>{t("no_notification")}</h5>
                          </div>
                        </Col>
                      ) : (
                        notification?.map((data, index) => (
                          <a
                            className="iq-sub-card"
                            key={index}
                            href={`${data?.redirectTo}?tab=${data?.tab}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-1 w-100">
                                <h6 className="mb-0 " dangerouslySetInnerHTML={{ __html: data?.notification}}></h6>
                                <div className="d-flex justify-content-between align-items-center mt-1">
                                  {data?.redirectTo && (
                                    <small
                                      className="float-left font-size-12"
                                      style={{ marginRight: "auto" }}
                                    >
                                      <a
                                        href={`${data?.redirectTo}?tab=${data?.tab}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary"
                                        style={{
                                          display: "flex",
                                          fontWeight: "600",
                                          justifyContent: "right",
                                          alignItems: "center",
                                        }}
                                      >
                                        {t("view")}
                                      </a>
                                    </small>
                                  )}
                                  <small
                                    className="float-right font-size-12"
                                    style={{ marginLeft: "auto" }}
                                  >
                                    {timeAgo(data?.createdAt)}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </a>
                        ))
                      )}
                    </Card.Body>
                  </Card>
                </Dropdown.Menu>
              </Dropdown>
             
              <Dropdown
                as="li" dir={isRTL ? "rtl" : "ltr"}
                className="nav-item"
                style={{ alignContent: "center" }}
                show={isDropdownVisible}
              >
                <Dropdown.Toggle
                  href="#"
                  as="div"
                  onClick={toggleDropdownLang}
                  className="d-flex align-items-center text-primary position-relative"
                  style={{ cursor: "pointer"}}
                >
                  <i
                    className="material-symbols-outlined text-primary"
                    title="Language"
                    style={{ fontSize: "24px", lineHeight: "1" }}
                  >
                    language
                  </i>
                  <span className="mobile-text d-none ms-3">{t("language")}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="sub-drop">
                  <Card className="shadow-none m-0">
                    <Card.Header className="d-flex justify-content-between bg-primary">
                      <div className="header-title bg-primary">
                        <h5 className="mb-0 text-white">{t("language")}</h5>
                      </div>
                      <div
                        className="text-white d-flex align-items-center justify-content-center"
                        style={{ width: "40px", height: "40px" }}
                        onClick={closeDropdownLang}
                      >
                        <span className="material-symbols-outlined">close</span>
                      </div>
                    </Card.Header>

                    <Card.Body
                      className="p-0 "
                      style={{ maxHeight: "60vh", overflowY: "auto", background:"#f5f5f7", border:"1px solid #d4d4d4", borderTop:"none", borderRadius:"5px"  }}
                    >
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("en")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">English</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("fr")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Français</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("de")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Deutsch</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("it")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Italiano</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("pt")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Português</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("ar")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">العربية</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("tr")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Türkçe</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("ru")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Русский</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("hi")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">हिन्दी</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("ja")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">日本語</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("ko")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">한국어</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("nl")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Nederlands</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("el")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Ελληνικά</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("th")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">ไทย</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("vi")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Tiếng Việt</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("uk")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Українська</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("ro")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Română</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("armenian")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Հայերեն</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("chinese")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">中文</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("mandarin")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">普通话</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("urdu")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">اردو</h6>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="iq-sub-card"
                        onClick={() => changeLanguage("es")}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-3">
                            <h6 className="mb-0 ">Español</h6>
                          </div>
                        </div>
                      </Link>
                    </Card.Body>
                  </Card>
                </Dropdown.Menu>
              </Dropdown>
              <Nav.Item className="nav-item d-none d-lg-none">
                <Link
                  to="#"
                  className="dropdown-toggle d-flex align-items-center"
                  id="mail-drop-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="material-symbols-outlined">mail</i>
                  <span className="mobile-text  ms-3">Message</span>
                </Link>
              </Nav.Item>

              <Dropdown as="li" className="nav-item user-dropdown"   show={showUserDropdown}
  onToggle={handleDropdownToggle}>
                <Dropdown.Toggle
                  href="#"
                  as={CustomToggle}
                  variant="d-flex align-items-center" 
                >
                  <img
                    src={
                      userData?.profileImageLink
                        ? userData?.profileImageLink
                        : "/profile.png"
                    }
                    className="img-fluid rounded-circle me-3"
                    alt="user"
                  />
                  <div className="caption d-none d-lg-block" >
                    <h6 className="mb-0 line-height">
                      {user?.firstName} {user?.lastName}
                    </h6>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="sub-drop caption-menu "
                  style={{ marginTop: "65px" }} dir={isRTL ? "rtl" : "ltr"}
                >
                  <Card className="shadow-none ">
                    <Card.Header>
                      <div className="header-title">
                        <h5 className="mb-0 ">
                          {t("hello")} {user?.firstName} {user?.lastName}
                        </h5>
                      </div>
                    </Card.Header>
                    <Card.Body className="p-0 ">
                      <div className="d-flex align-items-center iq-sub-card border-0"
                      onClick={toMyProfile}>
                        <span className="material-symbols-outlined">
                          line_style
                        </span>
                        <div className="ms-3">
                          <Link 
                          // to="/myprofile"
                           className="mb-0 h6">
                            {t("my_profile")}
                          </Link>
                        </div>
                      </div>
                      {viewProfile && (
                        <div
                          className="d-flex align-items-center iq-sub-card border-0"
                          onClick={profileNavigate}
                        >
                          <span className="material-symbols-outlined">
                            account_circle
                          </span>
                          <div className="ms-3">
                            <Link className="mb-0 h6">{t("profile_view")}</Link>
                          </div>
                        </div>
                      )}
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">
                          manage_accounts
                        </span>
                        <div className="ms-3">
                          <Link to="/account-setting" className="mb-0 h6" onClick={closeUserDropdown}>
                            {t("account_settings")}
                          </Link>
                        </div>
                      </div>
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">
                          add_circle
                        </span>
                        <div className="ms-3">
                          <Link to="/invite" className="mb-0 h6" onClick={closeUserDropdown}>
                            {t("invite_a_friend")}
                          </Link>
                        </div>
                      </div>
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">
                          announcement
                        </span>
                        <div className="ms-3">
                          <Link to="/announcement" className="mb-0 h6" onClick={closeUserDropdown}>
                            {t("announcement_title")}
                          </Link>
                        </div>
                      </div>
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">dvr</span>
                        <div className="ms-3">
                          <Link to="/services" className="mb-0 h6" onClick={closeUserDropdown}>
                            {t("services")}
                          </Link>
                        </div>
                      </div>
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">
                          assistant
                        </span>
                        <div className="ms-3">
                          <Link to="/leads" className="mb-0 h6" onClick={closeUserDropdown}>
                            {t("leads_title")}
                          </Link>
                        </div>
                      </div>
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">help</span>
                        <div className="ms-3">
                          {user?.isSocialNetPlanPaid ||
                          user?.isCriticalDPlanPaid ||
                          user?.isLostAndFoundPlanPaid ? (
                            <Link to="/help-support" className="mb-0 h6" onClick={closeUserDropdown}>
                              {t("help_and_support")}
                            </Link>
                          ) : (
                            <Link
                              to=""
                              className="mb-0 h6"
                              onClick={() =>
                                toast(
                                  "Please subscribe to a plan to access this feature."
                                )
                              }
                              // onClick={handlePlanRedirect}
                            >
                              {t("help_and_support")}
                            </Link>
                          )}
                        </div>
                      </div>
                      <div className="d-flex align-items-center iq-sub-card border-0">
                        <span className="material-symbols-outlined">login</span>
                        <div className="ms-3">
                          <Link
                            to=""
                            className="mb-0 h6"
                            onClick={handleLogout}
                          >
                            {t("sign_out")}
                          </Link>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </Container>
        </Nav>
        <div
          className="d-none d-lg-flex"
          style={{
            borderBottom: "1px solid #d3d3d3",
            paddingInline: "10px",
            display: "flex",
            justifyContent: "left",
            gap: "15px",
            cursor: "pointer",
            fontWeight: "600",
            textTransform:"uppercase"
          }}
        >
          <span> <Link
                to="#"
                // className="sidebar-toggle"
                data-toggle="sidebar"
                data-active="true"
                onClick={minisidebar}
              >
                <div className="icon material-symbols-outlined iq-burger-menu" style={{color:"black"}}>
                  menu
                </div>
              </Link></span> 
          <span onClick={() => handleNavigation("/hero-qr")}>{t("qr_hero")}</span> |
          <span onClick={() => handleNavigation("/request-qrc")}>
            {t("platinum_qrc")}
          </span>{" "}
          |<span onClick={() => handleNavigation("/critical")}>{t("critical_d")}</span>{" "}
          |
          <span onClick={() => handleNavigation("/device-list")}>
            {t("lost_and_found")}
          </span>{" "}
          |<span onClick={() => handleNavigation("/store-item")}>{t("store")}</span> |
          <span onClick={() => handleNavigation("/services")}>{t("services")}</span>
        </div>
      </div>
    </>
  );
};

export default Header;
